import cls from './Footer.module.scss'

export const Footer = () => (
    <footer className={cls.footer}>
        18+ © t2&nbsp;Россия, 2025
    </footer>
)